// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"717":"14172e3d4b161bed","4896":"9b03b0b527161ad0","7159":"bb2b14fec3ae2f49"}[chunkId] + ".js";
};